import { render, staticRenderFns } from "./DevelopemetProposalsConf.vue?vue&type=template&id=dbc6c3e0"
import script from "./DevelopemetProposalsConf.vue?vue&type=script&lang=js"
export * from "./DevelopemetProposalsConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports